import { d as se } from "./disableTabulationOnNotActiveSlidesWithModel-5413c83c.js";
const s = {
    section: "[data-section-type='product']",
    container: "[data-js-product-form]",
    product: "[data-js-product-json]",
    sku: ".js-product-sku",
    price: ".js-price",
    productPrice: "[data-product-price]",
    productPriceOld: "[data-price-old]",
    priceUnit: "[data-js-unit-price]",
    productSalePercentageBadge: ".js-sale-percentage-badge",
    productSalePercentage: "[data-sale-percentage]",
    variantId: '[name="id"]',
    submit: '[type="submit"]',
    quantityError: ".js-product-quantity-error",
    variants: "[data-js-product-variant]",
    variantElemJSON: "[data-selected-variant]",
    isPreset: "[data-is-preset]",
    productInventoryWrapper: ".js-product-inventory-wrapper",
    stickyBar: ".js-sticky-add-to-cart",
    stickyBarButton: ".js-sticky-add-to-cart-button",
    recipientCheckbox: ".js-recipient-form-checkbox",
    recipientFieldsContainer: ".js-recipient-form-fields",
    recipientField: ".js-recipient-form-field",
    recipientTimeZoneOffset: ".js-recipient-form-timezone-offset",
    recipientNoJsControl: ".js-recipient-form-no-js-control",
    customFieldGroup: ".js-custom-field-block",
    customFieldInput: ".js-custom-field-input",
    customFieldCheckbox: ".js-custom-field-checkbox",
    animate: ".js-animate",
    breaksVal: ".js-price-breaks-val",
    volumePricing: ".js-product-volume-pricing",
    quantityRuleMin: ".js-product-quantity-rule-min",
    quantityRuleMax: ".js-product-quantity-rule-max",
    quantityRuleIncrement: ".js-product-quantity-rule-increment",
    quantityRuleMinVal: ".js-product-quantity-rule-min-val",
    quantityRuleMaxVal: ".js-product-quantity-rule-max-val",
    quantityRuleIncrementVal: ".js-product-quantity-rule-increment-val",
    volumePricingList: ".js-product-volume-pricing-list",
    volumePricingJSON: "[data-product-qty-breaks-json]",
    volumePricingShowMore: ".js-product-volume-pricing-show-more",
    priceVolume: ".js-price-volume",
    formError: ".js-form-error",
    swatchLabelName: ".js-swatch-label-name",
    quantityRules: ".js-product-quantity-rules",
    productAddToCartText: ".js-product-add-to-cart-button-text",
};
let M = {};
const ee = { id: "id", isCurrencyEnabled: "data-currency-code-enabled" },
    Z = new Map();
let te = new AbortController(),
    ne = new AbortController();
const Ce = () => {
        let I,
            S,
            u,
            k,
            O,
            V = [],
            y = [];
        function j() {
            window.themeCore.utils.arrayIncludes,
                (I = window.themeCore.utils.convertFormData),
                (S = window.themeCore.utils.QuantityWidget),
                (u = window.themeCore.utils.cssClasses),
                (k = window.themeCore.utils.formatMoney),
                (O = window.themeCore.utils.getUrlWithVariant),
                (M = {
                    ...u,
                    onSale: "price--on-sale",
                    hidePrice: "price--hide",
                    animate: "js-animate",
                    animated: "animated",
                }),
                (V = le()),
                (y = ue()),
                J(),
                R(),
                ae(),
                ye(),
                de(),
                pe();
        }
        function J() {
            y.forEach(({ container: e }) => {
                e.addEventListener("change", Q), e.addEventListener("submit", X);
            }),
                window.themeCore.EventBus.listen("cart:updated", function (e) {
                    e &&
                        e.items &&
                        V.forEach(function (t) {
                            const n = K(t),
                                i = E(n);
                            A(t, n, i, !1), C(t, n), W(t, i);
                        });
                });
        }
        function R() {
            y.length &&
                y.forEach(({ container: e }) => {
                    const t = e.getAttribute("id");
                    window.themeCore.EventBus.listen(`form:${t}:change-variant`, B);
                });
        }
        function B({ currentVariant: e, elements: t, form: n, product: i, isTrusted: o }) {
            const r = E(e);
            o &&
                (D(e, n),
                d(t, e),
                d({ skuContainer: t.mobileSkuContainer }, e),
                N(t, e),
                v(i, e, n),
                w(t, e),
                q(t),
                P(t, e),
                $(e, n)),
                A(n, e, r, o),
                C(n, e),
                W(n, r);
        }
        function $(e, t) {
            const n = t.querySelector("pickup-availability");
            if (!n) return;
            const i = n.closest(".js-product-pickup-container");
            e && e.available
                ? n.fetchAvailability(e.id)
                : (n.removeAttribute("available"), (n.innerHTML = ""), i && i.classList.add(u.hidden));
        }
        function D(e, t) {
            t.querySelectorAll(s.swatchLabelName).forEach((i) => {
                if (!i) return;
                if (!e) {
                    const c = i.getAttribute("data-swatch-name"),
                        l = t.querySelector(`[data-option='${c}']:checked`);
                    l && (i.textContent = l.value);
                    return;
                }
                const r = "option" + i.getAttribute("data-swatch-position"),
                    a = e[r];
                a && (i.textContent = a);
            });
        }
        function N({ priceContainers: e }, t) {
            if (t) {
                if (!e.length) return;
            } else {
                e.forEach((n) => n.classList.add(M.hidePrice)), L(e, {});
                return;
            }
            e.forEach((n) => {
                const o = n.hasAttribute(ee.isCurrencyEnabled)
                        ? window.themeCore.objects.shop.money_with_currency_format
                        : window.themeCore.objects.shop.money_format,
                    { price: r, compare_at_price: a } = t,
                    c = a > r,
                    l = k(r, o),
                    p = k(a, o);
                n.classList.remove(M.hidePrice), c ? n.classList.add(M.onSale) : n.classList.remove(M.onSale);
                const m = n.querySelectorAll(s.productPrice),
                    g = n.querySelectorAll(s.productPriceOld);
                m.forEach((H) => (H.innerHTML = l)), g.forEach((H) => (H.innerHTML = p));

				m.forEach(function(element) {
                    element.classList.remove("wpd-processed");					
					element.setAttribute("data-wpd-variant-id", t.id);
					element.setAttribute("data-wpd-variant-compare-at-price",t.compare_at_price == null ? "":t.compare_at_price);
					element.setAttribute("data-wpd-variant-price",t.price);

				});

            }),
                L(e, t);
        }
        function v(e, t, n) {
            const o = [...n.closest(s.section).querySelectorAll(s.productSalePercentageBadge)];
            if (o.length) {
                if (!t || !e || !e.available) {
                    o.forEach((r) => r.classList.add(M.hidden));
                    return;
                }
                o.forEach((r) => {
                    const a = r.querySelector(s.productSalePercentage);
                    if (!a) {
                        r.classList.add(M.hidden);
                        return;
                    }
                    const { price: c, compare_at_price: l } = t;
                    if (l > c) {
                        const m = Math.floor((c * 100) / l);
                        (a.innerHTML = `-${100 - m}% ${window.themeCore.translations.get("products.product.sale")}`),
                            r.classList.remove(M.hidden);
                    } else r.classList.add(M.hidden);
                });
            }
        }
        function L(e, t) {
            e.forEach((n) => {
                const i = [...n.querySelectorAll(s.priceUnit)];
                if (!i.length) return;
                const o = i.find((p) => p.dataset.jsUnitPrice === "container"),
                    r = i.find((p) => p.dataset.jsUnitPrice === "money"),
                    a = i.find((p) => p.dataset.jsUnitPrice === "reference"),
                    c = t.unit_price,
                    l = t.unit_price_measurement;
                if (r)
                    if (c) {
                        const p = window.themeCore.objects.shop.money_format;
                        r.innerHTML = k(c, p);
                    } else r.innerHTML = "";
                if (a)
                    if (l) {
                        const p = l.reference_value,
                            m = l.reference_unit;
                        a.innerHTML = p !== 1 ? p + m : m;
                    } else a.innerHTML = "";
                o && (c || l)
                    ? o.classList.remove(window.themeCore.utils.cssClasses.hidden)
                    : o.classList.add(window.themeCore.utils.cssClasses.hidden);
            });
        }
        function d({ skuContainer: e }, t) {
            if (!e) return;
            let n = null;
            if ((t && (n = t.sku), !n)) {
                const o = e.closest(s.isPreset);
                if (o && o.dataset.isPreset === "true") return;
                e.innerHTML = "";
                return;
            }
            const i = e.dataset.skuText;
            e.innerHTML = i ? i.replaceAll("{SKU}", n).replaceAll("{sku}", n) : n;
        }
        function w({ variantIdContainer: e }, t) {
            if (!e || !t) return;
            const { id: n } = t;
            e.value = n;
        }
        function q({ quantityError: e }) {
            e && (e.innerHTML = "");
        }
        function P({ submit: e }, t) {
            const n = () => e.forEach((m) => m.removeAttribute("disabled")),
                i = () => e.forEach((m) => m.setAttribute("disabled", "disabled")),
                o = (m) =>
                    e.forEach((g) => {
                        const H = g.querySelector(s.productAddToCartText);
                        H.innerText = m;
                    }),
                r = e.some((m) => m.hasAttribute("data-preorder")),
                a = window.themeCore.translations.get("products.product.sold_out"),
                c = window.themeCore.translations.get("products.product.unavailable"),
                l = window.themeCore.translations.get("products.product.pre_order"),
                p = r ? l : window.themeCore.translations.get("products.product.add_to_cart");
            t && t.available ? (n(), o(p)) : t && !t.available ? (i(), o(a)) : (i(), o(c));
        }
        function C(e, t) {
            const i = y.find((H) => H.container.getAttribute("id") === e.getAttribute("id")).elements.quantityWidgetEl,
                o = e.querySelector(s.quantityRules);
            if (!o) return;
            if (!t || (t && !t.quantity_rule)) {
                o.classList.add(u.hidden);
                return;
            } else o.classList.remove(u.hidden);
            const r = t.quantity_rule,
                a = o.querySelector(s.quantityRuleIncrement),
                c = o.querySelector(s.quantityRuleMin),
                l = o.querySelector(s.quantityRuleMax),
                p = o.querySelector(s.quantityRuleIncrementVal),
                m = o.querySelector(s.quantityRuleMinVal),
                g = o.querySelector(s.quantityRuleMaxVal);
            p &&
                ((p.textContent = window.themeCore.translations.get("products.product.increments_of", {
                    number: r.increment,
                })),
                i.setIncrement(r.increment),
                r.increment > 1 ? a.classList.remove(u.hidden) : a.classList.add(u.hidden)),
                m &&
                    ((m.textContent = window.themeCore.translations.get("products.product.minimum_of", {
                        number: r.min,
                    })),
                    i.setMin(r.min),
                    i.toggleDecrease(),
                    i.toggleIncrease(),
                    r.min > 1 ? c.classList.remove(u.hidden) : c.classList.add(u.hidden)),
                g &&
                    (r.max !== null
                        ? ((g.textContent = window.themeCore.translations.get("products.product.maximum_of", {
                              number: r.max,
                          })),
                          l.classList.remove(u.hidden),
                          i.setMax(r.max))
                        : ((g.textContent = ""), l.classList.add(u.hidden), i.setMax("")),
                    i.toggleDecrease(),
                    i.toggleIncrease()),
                r.increment < 2 && r.min < 2 && r.max === null
                    ? o.classList.add(u.hidden)
                    : o.classList.remove(u.hidden);
        }
        function A(e, t, n, i) {
            const r = y.find((f) => f.container.getAttribute("id") === e.getAttribute("id")).elements.quantityWidgetEl;
            if (!e.querySelector("[name=id]")) return;
            const c = e.querySelector(s.volumePricing),
                l = e.querySelector(s.volumePricingList),
                p = e.querySelector(s.volumePricingJSON);
            let m = null;
            if (!p || !c) return;
            if (t) {
                if (((m = JSON.parse(p.innerHTML)[t.id].quantity_price_breaks), H(m), !i)) return;
                m.length ? (g(m), c.classList.remove(u.hidden)) : c.classList.add(u.hidden);
            } else c.classList.add(u.hidden);
            function g(f) {
                const h = e.querySelector(s.volumePricingShowMore),
                    T = window.themeCore.objects.shop.money_with_currency_format,
                    x = window.themeCore.translations.get("products.product.volume_pricing.each", {
                        price: k(t.price, T),
                    });
                h.addEventListener("click", function (b) {
                    b.preventDefault();
                    let U = l.querySelectorAll(".is-hidden");
                    U.length &&
                        (U.forEach(function (_) {
                            _.classList.remove(u.hidden);
                        }),
                        h.classList.add(u.hidden));
                }),
                    (l.innerHTML = "");
                let F = `
				<li class="product-volume-pricing__list-item">
					<span>${t.quantity_rule.min}<span aria-hidden>+</span></span>
					<span>${x}</span>
				</li>
			`;
                l.insertAdjacentHTML("beforeend", F),
                    f.forEach(function (b, U) {
                        let z = `
					<li class="product-volume-pricing__list-item ${U >= 2 ? `${u.hidden}` : ""}">
						<span>${b.minimum_quantity}<span aria-hidden>+</span></span>
						<span>${b.price_each}</span>
					</li>
				`;
                        l.insertAdjacentHTML("beforeend", z);
                    }),
                    f.length >= 3 ? h.classList.remove(u.hidden) : h.classList.add(u.hidden);
            }
            function H(f) {
                const h = e.querySelectorAll(s.priceVolume),
                    T = window.themeCore.objects.shop.money_with_currency_format,
                    x = window.themeCore.translations.get("products.product.volume_pricing.price_at_each", {
                        price: k(t.price, T),
                    });
                if (!h.length) return;
                if (!t) {
                    h.forEach((b) => b.classList.add(u.hidden));
                    return;
                }
                if (!f || !f.length) {
                    h.forEach((b) => (b.innerHTML = x)), h.forEach((b) => b.classList.remove(u.hidden));
                    return;
                }
                const F = f.findLast((b) => Number(n) + Number(r.quantity.value) >= b.minimum_quantity);
                if (!F) {
                    h.forEach((b) => (b.innerHTML = x)), h.forEach((b) => b.classList.remove(u.hidden));
                    return;
                }
                h.forEach((b) => (b.innerHTML = F.price_at_each)), h.forEach((b) => b.classList.remove(u.hidden));
            }
        }
        function E(e) {
            const t = window.themeCore.cartObject;
            if (!t || !e) return;
            if (!t.items.length) return 0;
            const n = t.items.find(function (i) {
                return i.variant_id === e.id;
            });
            return n ? n.quantity : 0;
        }
        function W(e, t) {
            if (!e) return;
            const n = e.querySelector(s.breaksVal);
            n &&
                (n.classList.toggle(u.hidden, !t),
                t || (n.innerHTML = ""),
                (n.innerHTML = window.themeCore.translations.get("products.product.quantity_in_cart", {
                    quantity: t,
                })));
        }
        async function Q({ currentTarget: e, target: t, isTrusted: n }) {
            const i = y.find(({ container: _, elements: { optionElements: z } }) => e === _);
            if (!i) return;
            if (t.hasAttribute("data-quantity-input")) {
                let _ = K(e),
                    z = E(_);
                A(e, _, z, !1), C(e, _), W(e, z);
            }
            if (!t || !t.hasAttribute("data-option")) return;
            t.tagName === "SELECT" &&
                t.selectedOptions.length &&
                (Array.from(t.options)
                    .find((_) => _.getAttribute("selected"))
                    .removeAttribute("selected"),
                t.selectedOptions[0].setAttribute("selected", "selected"));
            const o = e.closest("[data-section-type=product]"),
                r = o.getAttribute("data-section-id"),
                a = o.getAttribute("data-url"),
                c = e.querySelector(".js-product-options");
            if (!c) return;
            const l = Array.from(
                    c.querySelectorAll("select[data-option] option[selected], input[data-option]:checked")
                ).map(({ dataset: _ }) => _.optionValueId),
                p = l.length > 0 ? `&option_values=${l.join(",")}` : "",
                m = `${a}?section_id=${r}${p}`;
            let g;
            const H = Z.get(m);
            if (H) g = H;
            else
                try {
                    te.abort(),
                        (te = new AbortController()),
                        (g = await (await fetch(m, { signal: te.signal })).text()),
                        Z.set(m, g);
                } catch {
                    return;
                }
            oe(e);
            const f = new DOMParser().parseFromString(g, "text/html");
            c.innerHTML = f.querySelector(".js-product-options").innerHTML;
            let h = K(c),
                T = i.elements,
                x = i.product,
                F = e.querySelector(s.volumePricingJSON);
            F && f.querySelector(s.volumePricingJSON) && (F.innerHTML = f.querySelector(s.volumePricingJSON).innerHTML),
                document.querySelector(`#${t.id}`) && document.querySelector(`#${t.id}`).focus();
            const b = e.getAttribute("id");
            window.themeCore.EventBus.emit(`form:${b}:change-variant`, {
                form: e,
                product: x,
                currentVariant: h,
                elements: T,
                isTrusted: n,
            }),
                h &&
                    window.themeCore.EventBus.emit(`pdp:section-${r}:change-variant`, {
                        variantId: h.id,
                        variant: h,
                        product: x,
                        firstInitialization: !1,
                    });
            let U = e.querySelector(s.productInventoryWrapper);
            U &&
                f.querySelector(s.productInventoryWrapper) &&
                (U.outerHTML = f.querySelector(s.productInventoryWrapper).outerHTML),
                re(e) && ie(h),
                window.themeCore.EventBus.emit("accordion:init");
        }
        function Y(e) {
            let t = !1;
            return (
                e.forEach(function (n) {
                    const i = n.input.value.trim();
                    n.checkbox &&
                        (n.checkbox.checked && !i.length
                            ? (n.input.classList.add("error"), n.checkbox.classList.remove("error"), (t = !0))
                            : !n.checkbox.checked && i.length
                              ? (n.input.classList.remove("error"), n.checkbox.classList.add("error"), (t = !0))
                              : (n.input.classList.remove("error"), n.checkbox.classList.remove("error")));
                }),
                t
            );
        }
        function X(e) {
            const t = e.target;
            e.preventDefault();
            const n = y.find((a) => a.id === t.getAttribute(ee.id)),
                i = n.elements.customFieldElements;
            if (i && Y(i)) return;
            if (n) {
                const { submit: a } = n.elements;
                a.forEach((c) => c.classList.add(M.loading));
            }
            const o = new FormData(t),
                r = I(o);
            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.ADD_TO_CART, r)
                .then((a) => {
                    G(a, n);
                })
                .catch((a) => {
                    ce(a, n);
                });
        }
        function G(e, t) {
            if (!t) return;
            const n = t.container,
                { quantityWidget: i, submit: o } = t.elements;
            i && i.setValue(0),
                o.forEach((r) => r.classList.remove(M.loading)),
                he(n),
                window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
        }
        function ce(e, t) {
            if (!t) return;
            const n = t.container,
                i = n.querySelector(s.recipientCheckbox);
            let { description: o } = e;
            const { quantityError: r, submit: a } = t.elements;
            if (typeof o == "object" && i) {
                const c = t.container.dataset.sectionId;
                let l = e.errors;
                const p = n.querySelectorAll(s.formError),
                    m = n.querySelectorAll(s.recipientField);
                return (
                    p.length &&
                        m.length &&
                        (p.forEach(function (g) {
                            g.classList.add(M.hidden), (g.innerText = "");
                        }),
                        m.forEach(function (g) {
                            g.setAttribute("aria-invalid", !1), g.removeAttribute("aria-describedby");
                        })),
                    Object.entries(l).forEach(([g, H]) => {
                        const f = `RecipientForm-${g}-error-${c}`,
                            h = n.querySelector(`#${f}`),
                            T = `Recipient-${g}-${c}`,
                            x = n.querySelector(`#${T}`);
                        let F = `${H.join(", ")}`;
                        g === "send_on" && (F = `${H.join(", ")}`),
                            h && ((h.innerText = F), h.classList.remove(M.hidden)),
                            x && (x.setAttribute("aria-invalid", !0), x.setAttribute("aria-describedby", f)),
                            a.forEach((b) => b.classList.remove(M.loading));
                    })
                );
            }
            r && (r.innerHTML = o), a.forEach((c) => c.classList.remove(M.loading));
        }
        function K(e) {
            if (!e) return;
            const t = e.querySelector(s.variantElemJSON);
            return t ? JSON.parse(t.innerHTML) : null;
        }
        function ie(e) {
            if (!e) return null;
            const t = O(window.location.href, e.id);
            window.history.replaceState({ path: t }, "", t);
        }
        function re(e) {
            return e.dataset.enableHistoryState || !1;
        }
        function ae() {
            y.forEach(async (e) => {
                let t = K(e.container);
                if (
                    (B({
                        currentVariant: t,
                        elements: e.elements,
                        form: e.container,
                        product: e.product,
                        isTrusted: !0,
                    }),
                    t)
                ) {
                    const i = e.container.closest("[data-section-type=product]").getAttribute("data-section-id");
                    window.themeCore.EventBus.emit(`pdp:section-${i}:change-variant`, {
                        variantId: t.id,
                        variant: t,
                        product: e.product,
                        firstInitialization: !0,
                    });
                }
                re(e.container) && ie(t), await oe(e.container);
            });
        }
        function le() {
            return [...document.querySelectorAll(s.container)];
        }
        function ue() {
            return V.reduce((e, t) => {
                const n = t.querySelector(s.product);
                let i = {};
                try {
                    i = JSON.parse(n.innerHTML);
                } catch {
                    return e;
                }
                const o = t.getAttribute(ee.id),
                    r = [...t.querySelectorAll(s.submit)],
                    a = t.querySelector(s.sku),
                    c = [...t.querySelectorAll(s.price)],
                    l = t.querySelector(s.quantityError),
                    p = t.querySelector(s.variantId);
                let m = [...t.querySelectorAll("[data-option]")],
                    g = null;
                const H = S(t, {
                        onQuantityChange: (T) => {
                            q({ quantityError: l });
                        },
                    }).init(),
                    h = [...t.querySelectorAll(s.customFieldGroup)].map(function (T) {
                        let x = T.querySelector(s.customFieldInput),
                            F = T.querySelector(s.customFieldCheckbox);
                        return { input: x, checkbox: F };
                    });
                return [
                    ...e,
                    {
                        id: o,
                        container: t,
                        product: i,
                        elements: {
                            skuContainer: a,
                            priceContainers: c,
                            quantityWidgetEl: H,
                            quantityError: l,
                            variantIdContainer: p,
                            submit: r,
                            mobileSkuContainer: g,
                            optionElements: m,
                            customFieldElements: h,
                        },
                    },
                ];
            }, []);
        }
        function de() {
            V.forEach((e) => {
                const t = e.querySelector(s.stickyBar),
                    n = e.querySelector(s.submit);
                if (!t || !n) return;
                new IntersectionObserver((o) => {
                    o.forEach((r) => {
                        const a = n.getBoundingClientRect();
                        if (
                            (t.classList.toggle(
                                window.themeCore.utils.cssClasses.active,
                                !r.isIntersecting && a.bottom < 0
                            ),
                            !r.isIntersecting)
                        ) {
                            const c = t.closest(s.animate);
                            c && c.classList.remove(M.animate), c && c.classList.add(M.animated);
                        }
                    });
                }, {}).observe(n),
                    t.addEventListener("click", (o) => {
                        o.target.closest(s.stickyBarButton) && n.focus();
                    });
            });
        }
        function pe() {
            V.forEach((e) => {
                const t = e.querySelector(s.recipientCheckbox),
                    n = e.querySelector(s.recipientFieldsContainer),
                    i = e.querySelectorAll(s.recipientField),
                    o = e.querySelector(s.recipientTimeZoneOffset),
                    r = e.querySelector(s.recipientNoJsControl);
                if (!t || !n || !i || !o) return;
                (o.value = new Date().getTimezoneOffset().toString()),
                    (r.disabled = !0),
                    (t.disabled = !1),
                    a(),
                    t.addEventListener("change", function () {
                        t.checked ? (n.classList.remove(M.hidden), c()) : (n.classList.add(M.hidden), a());
                    });
                function a() {
                    i.forEach(function (l) {
                        l.disabled = !0;
                    }),
                        (o.disabled = !0);
                }
                function c() {
                    i.forEach(function (l) {
                        l.disabled = !1;
                    }),
                        (o.disabled = !1);
                }
            });
        }
        function me(e) {
            if (!e.querySelector(s.recipientCheckbox)) return;
            const i = e.querySelector(s.recipientFieldsContainer).querySelectorAll(s.formError),
                o = e.querySelectorAll(s.recipientField);
            !i ||
                !o ||
                (i.forEach(function (r) {
                    r.classList.add(M.hidden), (r.innerText = "");
                }),
                o.forEach(function (r) {
                    r.setAttribute("aria-invalid", !1), r.removeAttribute("aria-describedby");
                }));
        }
        function fe(e) {
            if (!e.querySelector(s.recipientCheckbox)) return;
            const n = e.querySelectorAll(s.recipientField);
            n &&
                n.forEach(function (i) {
                    i.value = "";
                });
        }
        function he(e) {
            const t = e.querySelector(s.recipientCheckbox);
            t && t.checked && ((t.checked = !1), t.dispatchEvent(new Event("change")), me(e), fe(e));
        }
        function ye() {
            V.forEach((e) => {
                const t = e.querySelector(s.variants);
                t && t.dataset.jsProductVariant !== "no-hidden" && t.classList.add(u.hidden);
            });
        }
        function ge(e) {
            const t = e.reduce((a, c) => (a[c.name] || (a[c.name] = []), a[c.name].push(c), a), {}),
                n = Object.values(t);
            function i(a) {
                return a.reduce(
                    (c, l) => {
                        const p = [];
                        return (
                            c.forEach((m) => {
                                l.forEach((g) => {
                                    p.push([...m, g]);
                                });
                            }),
                            p
                        );
                    },
                    [[]]
                );
            }
            return i(n).map((a) => ({
                option_values: a.map((c) => c.value).join(","),
                selected: a.every((c) => c.selected),
                options: a,
            }));
        }
        function Se(e) {
            const t = e.find((i) => i.selected);
            if (!t) return e;
            const n = t.options.map((i) => i.value);
            return e.sort((i, o) => {
                const r = i.options.filter((p) => n.includes(p.value)).length,
                    a = o.options.filter((p) => n.includes(p.value)).length,
                    c = n.length - r,
                    l = n.length - a;
                return c !== l ? c - l : 0;
            });
        }
        async function be(e) {
            const t = await fetch(e, { signal: ne.signal });
            if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
            return await t.text();
        }
        async function oe(e) {
            const t = e.querySelector(".js-product-options");
            if (!t) return;
            const n = e.closest("[data-section-type=product]"),
                i = n.getAttribute("data-section-id"),
                o = n.getAttribute("data-url"),
                r = Array.from(t.querySelectorAll("select[data-option] option, input[data-option]")).map((f) => {
                    var h, T;
                    return {
                        name:
                            f.dataset.option ||
                            ((T = (h = f.closest("select")) == null ? void 0 : h.dataset) == null ? void 0 : T.option),
                        value: f.dataset.optionValueId,
                        selected: f.matches("[selected], :checked"),
                    };
                }),
                a = ge(r),
                m = Se(a)
                    .filter((f) => !Array.from(Z.keys()).some((h) => h.includes(f.option_values)))
                    .slice(0, 20)
                    .map(({ option_values: f }) => `${o}?section_id=${i}&option_values=${f}`);
            ne.abort(), (ne = new AbortController());
            const g = m.map((f) => be(f));
            (await Promise.allSettled(g)).forEach((f, h) => {
                if (f.status === "fulfilled") {
                    const T = m[h];
                    Z.set(T, f.value);
                }
            });
        }
        function ve() {
            return y;
        }
        return Object.freeze({ init: j, allForms: ve });
    },
    qe = ({ config: I, selectors: S, sectionId: u }) => {
        const k = window.themeCore.utils.Swiper,
            O = window.themeCore.utils.extendDefaults;
        S = O(
            {
                slider: ".js-product-media-slider",
                sliderNavigationNext: ".js-product-media-slider-next",
                sliderNavigationPrev: ".js-product-media-slider-prev",
                sliderSlideVariantId: ".js-product-gallery-slide-variant",
                sliderPagination: ".js-product-media-pagination",
                activeClass: ".swiper-slide-active",
                modelPoster: ".js-product-media-model-poster",
                notInitedIframe: ".js-video.js-video-youtube, .js-video:empty",
            },
            S
        );
        let y = null,
            j = !1;
        function J() {
            if (j) return y;
            let v = document.querySelector(S.slider).dataset.autoHeight,
                L = document.querySelector(S.sliderNavigationPrev),
                d = document.querySelector(S.sliderNavigationNext),
                w = document.querySelector(S.sliderPagination);
            if (
                ((v = v === "true"),
                (y = new k(S.slider, {
                    ...I,
                    autoHeight: v,
                    slidesPerView: "auto",
                    speed: 800,
                    navigation: { nextEl: d, prevEl: L },
                    pagination: { type: "progressbar", el: w },
                })),
                w)
            ) {
                let A = w.closest(".js-product-media-pagination-wrapper");
                A && A.classList.remove("opacity-0");
            }
            y.on("slideChange", function (A) {
                const E = A.slides[A.activeIndex];
                E && (A.allowTouchMove = !(E.hasAttribute("data-model-slide") && !E.querySelector(S.modelPoster)));
            });
            const q = document.querySelector(S.slider),
                P = new MutationObserver(() => {
                    q.querySelector(S.notInitedIframe) || (se(y), P.disconnect());
                }),
                C = { attributes: !0, childList: !0, subtree: !0 };
            P.observe(q, C), R(), (j = !0);
        }
        function R() {
            y &&
                (y.on("slideChange", function (N) {
                    window.themeCore.EventBus.emit("product-slider:slide-change"), se(N);
                }),
                window.themeCore.EventBus.listen(`pdp:section-${u}:change-variant`, B));
        }
        function B({ variant: N }) {
            if (!y) return;
            let v = null;
            N.featured_media && (v = N.featured_media.id);
            const L = [...y.slides].findIndex((d) => {
                const w = d.querySelector(S.sliderSlideVariantId);
                return w ? w.getAttribute("data-media-id").includes(v) : !1;
            });
            L === !1 || L === -1 || y.slideTo(L);
        }
        function $() {
            y && j && (y.destroy(), (y = null)), (j = !1);
        }
        function D() {
            y && (y.allowTouchMove = !1);
        }
        return Object.freeze({ init: J, destroy: $, disableSwipe: D });
    },
    Ee = (I) => {
        const S = {
                mediaContainer: ".js-product-media-container",
                mediaItem: ".js-product-media-item",
                mediaItemVariant: ".js-product-media-item-variant",
                header: ".js-header",
                cssRoot: ":root",
            },
            u = {
                enableMediaScroller: "data-enable-media-scroller",
                staticHeader: "data-static-header",
                hideOnScrollHeader: "data-hide-on-scroll-down",
            },
            k = { headerHeightStatic: "--header-height-static", headerHeight: "--header-height" },
            O = { afterMedium: "(min-width: 1200px)" },
            V = I && I.dataset.sectionId,
            y = document.querySelector(S.cssRoot);
        let j;
        function J() {
            if (!I) return;
            const v = I.querySelector(S.mediaContainer);
            !v || !v.hasAttribute(u.enableMediaScroller) || R();
        }
        function R() {
            window.themeCore.EventBus.listen(`pdp:section-${V}:change-variant`, B);
        }
        function B({ variant: v, variantId: L, firstInitialization: d }) {
            if (j === L || ((j = L), !window.matchMedia(O.afterMedium).matches || d)) return;
            let q = null;
            v.featured_media && (q = v.featured_media.id);
            const A = [...I.querySelector(S.mediaContainer).querySelectorAll(S.mediaItem)].find((E) => {
                const W = E.querySelector(S.mediaItemVariant);
                return W ? W.getAttribute("data-media-id").includes(q) : !1;
            });
            if (!A) return null;
            $(A);
        }
        function $(v) {
            const L = I.getBoundingClientRect(),
                d = v.getBoundingClientRect(),
                w = Math.round(d.top),
                q = Math.round(L.top),
                P = Math.round(L.bottom),
                C = Math.round(window.scrollY),
                A = 16;
            let E = C + w - A;
            const W = C + q - A,
                Q = C + P + A;
            E = Math.max(E, W);
            const Y = D(),
                X = Y === 0 ? E : E - Y + A;
            if (Math.abs(C - X) <= 1) return;
            const G = N(C, E);
            (E = G === 0 ? E : E - G + A),
                (E = Math.min(E, Q - window.innerHeight)),
                window.scrollTo({ top: E, behavior: "smooth" });
        }
        function D() {
            const v = document.querySelector(S.header);
            if (!v || v.hasAttribute(u.staticHeader)) return 0;
            const d = y.style.getPropertyValue(k.headerHeight);
            return d ? parseInt(d) : 0;
        }
        function N(v, L) {
            const d = document.querySelector(S.header);
            if (!d) return 0;
            const w = d.hasAttribute(u.staticHeader),
                q = d.hasAttribute(u.hideOnScrollHeader),
                P = y.style.getPropertyValue(k.headerHeightStatic),
                C = P ? parseInt(P) : 0;
            return w || (q && v < L - C) ? 0 : C;
        }
        return Object.freeze({ init: J });
    },
    Le = (I) => {
        const S = window.themeCore.utils.on,
            u = 1,
            k = 100,
            O = {
                stickyContainer: ".js-product-sticky-container",
                headerContentWrapper: "[data-header-container]",
                headerSticky: "[data-header-sticky]",
                cssRoot: ":root",
            },
            V = { headerHeightStatic: "--header-height-static" },
            y = { afterMedium: 1200 },
            j = [...I.querySelectorAll(O.stickyContainer)],
            J = document.querySelector(O.cssRoot);
        let R = D(),
            B = window.innerHeight,
            $ = window.scrollY;
        function D() {
            const d = document.querySelector(O.headerContentWrapper);
            if (!d || !d.closest(O.headerSticky)) return u;
            const q = J.style.getPropertyValue(V.headerHeightStatic);
            return q ? parseInt(q) : u;
        }
        function N() {
            if (j) {
                const d = j.reduce((w, q) => (q.offsetHeight > (w && w.offsetHeight) ? w : q));
                v(d);
            }
        }
        function v(d) {
            !d ||
                !I ||
                ((d.style.top = R + "px"),
                S("scroll", () => {
                    L(d);
                }));
        }
        function L(d) {
            if (window.innerWidth < y.afterMedium) return;
            R = D();
            let w = d.getBoundingClientRect().height || 0,
                q = B - w + R;
            setTimeout(() => {
                let P = window.scrollY;
                if (
                    ((B = window.innerHeight),
                    (w = d.getBoundingClientRect().height || 0),
                    q < R && ($ > q ? (I.style.top = `${B - w}px`) : (I.style.top = `${$}px`)),
                    P > $)
                ) {
                    let C = parseInt(d.style.top.replace("px", ""));
                    if (!C) return;
                    C > B - w - Math.ceil(d.clientHeight / k) &&
                        (d.style.top = `${C - Math.ceil(d.clientHeight / k)}px`);
                } else if (P < $) {
                    let C = parseInt(d.style.top.replace("px", ""));
                    if (!C) return;
                    C < R && (d.style.top = `${C + Math.ceil(d.clientHeight / k)}px`);
                }
                $ = window.scrollY;
            }, 0);
        }
        return Object.freeze({ init: N });
    };
export { qe as P, Le as a, Ee as b, Ce as c };
